import React from "react";
import "../../App.css";
import Requestform from "../Requestform";

export default function Request() {
  return (
    <div className="request">
      <Requestform />
    </div>
  );
}
